import styled from 'styled-components';

const Title = styled.h1`
  font-family: ${(props) => props.theme.font.family};
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: ${(props) => props.theme.font.size.huge};
  color: ${(props) => props.theme.colors.header};
  font-stretch: normal;
  font-style: normal;
  line-height: 0.9;
  letter-spacing: normal;
`;

export default Title;
